export const columns =[
    {
        key:"count",
        header:"S.",
        isSortable:false,
        className:"count"
    },
    {
        key:"state",
        header:"State",
        isSortable:true,
        className:"dark"
    },
    {
        key:"region",
        header:"Region",
        isSortable:true,
        className:"dark"
    },

]

export type RegionData = {
  id?: string;
  region: string;
  state: string;
};

export type AddEditRegionModalProps = {
  isEdit:boolean;
  isOpen: boolean;
  onClose: () => void;
  initialData?: RegionData | null;
  onSuccess?: () => void;
};